import { render } from "./intro-comp.vue?vue&type=template&id=3bc219cd&scoped=true"
import script from "./intro-comp.vue?vue&type=script&lang=js"
export * from "./intro-comp.vue?vue&type=script&lang=js"

import "./intro-comp.vue?vue&type=style&index=0&id=3bc219cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc219cd"]])

export default __exports__